<template>
  <div class="viq-briefing">
    <h3 class="viq-briefing__title">What should this report cover?</h3>
    <p class="viq-briefing__desc">
      Describe the topic, jurisdictions, and scope for your board report. Be as specific as possible for better results.
    </p>

    <div class="viq-briefing__field">
      <el-input
        v-model="topic"
        type="textarea"
        :rows="4"
        placeholder="e.g., PSD3 implementation impact on payment processors across EU member states, focusing on licensing and operational requirements..."
        :disabled="loading"
      />
    </div>

    <div class="viq-briefing__actions">
      <el-button @click="goBack">
        Back
      </el-button>
      <el-button type="primary" :loading="loading" :disabled="!topic.trim()" @click="submit">
        Generate Outline
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqReportBriefing",
  data() {
    return {
      topic: "",
      loading: false,
    };
  },
  mounted() {
    // Pre-fill from store if coming from input area
    const briefing = this.$store.state.Viq.reportBriefing;
    if (briefing && briefing.topic) {
      this.topic = briefing.topic;
    }
  },
  methods: {
    async submit() {
      if (!this.topic.trim()) return;
      this.loading = true;
      try {
        await this.$emit("submit", this.topic.trim());
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$store.commit("Viq/SET_REPORT_STEP", 0);
      this.$store.commit("Viq/SET_REPORT_TYPE", null);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-briefing {
  padding: $viq-space-lg 0;

  &__title {
    font-size: $viq-font-lg;
    font-weight: 700;
    color: $viq-text-primary;
    margin: 0 0 $viq-space-sm;
  }

  &__desc {
    font-size: $viq-font-base;
    color: $viq-text-secondary;
    margin: 0 0 $viq-space-lg;
    line-height: 1.5;
  }

  &__field {
    margin-bottom: $viq-space-lg;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: $viq-space-sm;
  }
}
</style>
